/** Forms sending by "js-form-send" class on submit-btn */
$(function () {
    // Send-button and it's parent form
    const btn = $('.js-form-send');
    const form = btn.closest('form');

    // Fields to validate
    const formFieldsToValidate = form.find('input, textarea').not('input[type=hidden]');
    // console.log(formFieldsToValidate);

    // Footer and btn-up
    const footer = $('.b-footer');
    const footerBtnUp = $('.b-footer__btn-up');

    /** Response templates: */
    // Default success-response template
    let responseSuccessTitle = 'Благодарим за обращение в компанию<br> Webcom Performance!';

    let responseSuccessDesc =
        '<p>Наш менеджер свяжется с вами по указанному телефону в течение часа.'
        + '<br> (рабочее время: с понедельника по пятницу 9:00-18:00)</p>';

    let responseSuccessImgSrc = '/local/templates/webcom_2018/images/modals/form-response_icon.svg';

    let responseSuccessTpl =
        '<div class="b-popup b-popup--response b-popup--response-success b-popup--dynamic" id="form_response_success">'
            +'<div class="b-popup__inner">'
                +'<div class="b-popup__img-wrap">'
                    +'<img class="b-popup__img" src="'+responseSuccessImgSrc+'" alt="form-response">'
                +'</div>'
                +'<div class="b-popup__text">'
                    +'<p class="b-popup__title b-popup__title--orange">'+responseSuccessTitle+'</p>'
                    +'<div class="b-popup__desc">'+responseSuccessDesc+'</div>'
                +'</div>'
            +'</div>'
        +'</div>';


    // Error-response template
    let responseErrorTitle = 'Произошла ошибка!';

    let responseErrorDesc =
        '<p>К сожалению, ваше письмо не отправлено! Попробуйте повторить отправку в ближайшее время.</p>';

    let responseErrorImgSrc = '/local/templates/webcom_2018/images/modals/form-response-error_icon.svg';

    let responseErrorTpl =
        '<div class="b-popup b-popup--response b-popup--response-error b-popup--dynamic" id="form_response_error">'
            +'<div class="b-popup__inner">'
                +'<div class="b-popup__img-wrap b-popup__img-wrap--red">'
                    +'<img class="b-popup__img" src="'+responseErrorImgSrc+'" alt="form-response">'
                +'</div>'
                +'<div class="b-popup__text">'
                    +'<p class="b-popup__title b-popup__title--red">'+responseErrorTitle+'</p>'
                    +'<div class="b-popup__desc">'+responseErrorDesc+'</div>'
                +'</div>'
            +'</div>'
        +'</div>';



    /** Get google Client ID */
    const getGaClientId = function() {
        let gaClientId = '';

        // Get from ga tracker
        // Orig: https://developers.google.com/analytics/devguides/collection/analyticsjs/domains#getClientId
        if (typeof ga !== 'undefined') {
            ga(function(tracker) {
                gaClientId = tracker.get('clientId');
            });

            // console.log('ga_client_id taken from ga-tracker');
        }
        // Alternative method - get from cookies by "_ga" name
        else {
            // Get cookie by it's name
            const getCookie = function(name) {
                let matches = document.cookie.match(new RegExp(
                    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
                ));
                // console.log(matches);

                return matches ? decodeURIComponent(matches[1]) : '';
            };

            const fullString = getCookie('_ga');
            // console.log(fullString);

            if (fullString) {
                // Split string
                const stringPartsArr = fullString.split('.');
                // console.log(stringPartsArr);

                // Concatenate two last parts
                gaClientId = stringPartsArr[2] + '.' + stringPartsArr[3];
            }

            // console.log('ga_client_id taken from cookies');
        }

        return gaClientId;
    };
    //console.log('client id: ' + getGaClientId());



    /** Url-parsing by "Sourcebuster" library - http://sbjs.rocks/ */
    const utmParamsObj = {}; // Empty object for utm-params
    const locationHost = window.location.host;

    sbjs.init({
        // Cookies life-time in months
        lifetime: 1,

        // User life-time in minutes
        session_length: 30,

        // Domain name in cookies
        domain: {
            host: locationHost,
            isolate: false
        },

        // Timezone
        timezone_offset: 3,

        // Callback
        callback: getUtmParams
    });

    // Get utm-params after url-parsing
    function getUtmParams() {
        // Add values to object
        utmParamsObj.utm_source = sbjs.get.current.src || '';
        utmParamsObj.utm_medium = sbjs.get.current.mdm || '';
        utmParamsObj.utm_campaign = sbjs.get.current.cmp || '';
        utmParamsObj.utm_content = sbjs.get.current.cnt || '';
        utmParamsObj.utm_term = sbjs.get.current.trm || '';

        // utmParamsObj.current_visit_date = sbjs.get.current_add.fd || '';
        // utmParamsObj.traffic_type = sbjs.get.current.typ || '';
        // utmParamsObj.first_entrance_point = sbjs.get.current_add.ep || '';
        // utmParamsObj.referer_url = sbjs.get.current_add.rf || '';
        // utmParamsObj.current_page_url = sbjs.get.session.cpg || '';
        // utmParamsObj.current_session_pages_visited = sbjs.get.session.pgs || '';
        // utmParamsObj.site_visited_times = sbjs.get.udata.vst || '';
        // utmParamsObj.promocode = sbjs.get.promo.code || '';
    }



    /** Custom-validation from global-variable "ValidateFormField" (forms-validation.js) */
    if (typeof ValidateFormField !== 'undefined') {
        // Create new instance of object
        const isValidField = new ValidateFormField();
        // console.log(isValidField);

        // Validation by 'input' and 'change' events
        formFieldsToValidate.on('input change', function () {
            const fieldObj = $(this)[0]; // Js-object (not jquery-object)
            // console.log(fieldObj);

            // Access to custom method ".validate"
            if (
                isValidField.validate
                && isValidField.validate(fieldObj)
            )
            {
                $(this).removeClass('invalid');
            }
            else {
                $(this).addClass('invalid');
            }
        });
    }



    /** Form validation and sending */
    $('body').on('click', '.js-form-send', function (event) {
        event.preventDefault();

        const currentForm = $(this).closest('form');
        // console.log(currentForm);

        /** Validation by click on send-button */
        if (checkIsFormValid(currentForm)) {
            const currentFormFields = currentForm.find('input, textarea');
            const currentFormPreloader = currentForm.find('.b-form__preloader');

            const locationHref = window.location.href;
            const locationPathname = window.location.pathname;
            const locationPathnameSlug = locationPathname.substr(0, locationPathname.length - 1).split('/').pop();


            // Lead-title in bitrix24 crm
            const leadTitleInCrm = $('h1.b-header__title').text()
                || $('title').text()
                || locationPathnameSlug;
            // console.log(leadTitleInCrm);


            // Form-Id for analytics
            const formAnalyticsId = currentForm.data('form-id')
                || locationPathnameSlug;
            // console.log(formAnalyticsId);


            // New empty data-object
            const formData = new FormData();


            // Adding fields values to formData (as an array of objects)
            const fields = currentForm.serializeArray();
            // console.log(fields);

            $.each(fields,function(i, field) {
                formData.append(field.name,field.value);
            });

            let componentName = currentForm.data('component');
            // Adding custom values
            formData.append('submit','Y');
            formData.append('component', componentName);
            formData.append('signedParameters', component.signedParameters);
            formData.append('lead_title_in_crm',leadTitleInCrm);
            formData.append('page_url',locationHref);
            formData.append('ga_client_id',getGaClientId());


            // Adding utm-params
            for (let key in utmParamsObj) {
                formData.append(key,utmParamsObj[key]);
                // console.log( "key: " + key + " value: " + utmParamsObj[key] );
            }
            // console.log(utmParamsObj);


            // Check keys-values of formData (only for development)
            // for (let [key, value] of formData) {
            //     console.log(key + ': ' + value);
            // }

            var query = {
                c: componentName,
                action: 'submit',
                mode: 'class'
            };


            /** Send data */
            $.ajax({
                type: 'POST',
                dataType: 'json',
                url: '/bitrix/services/main/ajax.php?' + $.param(query, true),
                contentType: false,
                processData: false,
                data: formData,
                beforeSend: function () {
                    // Prevent dublicate sending
                    currentFormFields.prop('disabled', true);

                    // Show preloader
                    currentFormPreloader.addClass('js-active');
                }
            })
            .done(function (response) {
                // console.log(response);

                if (response) {
                    try {
                        if (response.status === 'ok') {
                            showSuccessModal();

                            // Sending events to analytics
                            if (typeof dataLayer !== 'undefined' && formAnalyticsId) {
                                dataLayer.push({'event': formAnalyticsId + "_Order"});
                            }

                            // Clear form fields
                            currentForm[0].reset();
                        }

                        if (response.status === 'redirect') {
                            window.location.href = locationHref;
                        }

                    } catch(e) {
                        console.log(e.name + ":" + e.message + "\n" + e.stack);

                        showErrorModal();
                    }

                } else {
                    showErrorModal();
                }
            })
            .fail(function (xhr) {
                console.log("xhr error: " + xhr.status + " " + xhr.statusText);

                showErrorModal();
            })
            .always(function() {
                currentFormFields.prop('disabled', false);
                currentFormPreloader.removeClass('js-active');
            });

        } else {
            // Scroll to first invalid-field for all forms, except forms with class "validate-no-scroll"
            const firstInvalidField = currentForm.find('.invalid').eq(0);

            if (currentForm.hasClass('validate-no-scroll')) {
                firstInvalidField.focus();
            }
            else {
                $('html, body').animate({
                    scrollTop: firstInvalidField.offset().top - 200
                }, 500, function () {
                    firstInvalidField.focus();
                });
            }
        }

        return false;
    });



    /** Check is form valid */
    function checkIsFormValid(currentForm) {
        let isValidForm = true;
        const formFieldsToValidate = currentForm.find('input, textarea').not('input[type=hidden]');

        /** Custom-validation from global-variable "ValidateFormField" (forms-validation.js) */
        if (typeof ValidateFormField !== 'undefined') {
            // Create new instance of object
            const isValidField = new ValidateFormField();
            // console.log(isValidField);

            $.each(formFieldsToValidate, function () {
                const fieldObj = $(this)[0]; // Js-object (not jquery-object)
                // console.log(fieldObj);

                // Access to custom method ".validate"
                if (
                    isValidField.validate
                    && !isValidField.validate(fieldObj)
                )
                {
                    $(this).addClass('invalid');

                    isValidForm = false;
                }
            });
        }

        return isValidForm;
    }



    /** Other */
    // Show success modal
    function showSuccessModal() {
        closeCurrentModal();

        // Open new fancybox-window
        $.fancybox.open({
            src: responseSuccessTpl,
            type: 'html',
            beforeLoad: function (instance) {
                // Update position and content of all slides
                instance.update();
            }
        });
    }


    // Show error modal
    function showErrorModal() {
        $.fancybox.open({
            src: responseErrorTpl,
            type: 'html',
            beforeLoad: function(instance) {
                // Update position and content of all slides
                instance.update();
            }
        });
    }


    // Close current fancybox-modal
    function closeCurrentModal() {
        // Get currently active instance
        const currentInstance = $.fancybox.getInstance();

        if (currentInstance) {
            // Close instance
            currentInstance.close();
        }
    }


    // Check window width
    if (window.currentScreen && window.currentScreen !== 'desktop') {
        // Hide btn-up when field has focus (prevent bugs on mobile-devices)
        formFieldsToValidate.on('focus', function () {
            if (footer.length && footerBtnUp.length) {
                footer.css('padding-top', 0);

                footerBtnUp.addClass('js-hidden');
            }
        });

        // Show btn-up when field loose focus
        formFieldsToValidate.on('blur', function () {
            if (footer.length && footerBtnUp.length) {
                let footerBtnUpHeight = footerBtnUp.outerHeight() || 0;
                footer.css('padding-top', footerBtnUpHeight);

                footerBtnUp.removeClass('js-hidden');
            }
        });
    }


    // Init datetimepicker for date-fields
    $('.datetimepicker').each(function () {
        $(this).datetimepicker({
            locale: 'ru',
            minDate: moment().add(10, 'minutes'),
            useCurrent: false,
            daysOfWeekDisabled: [0, 6],
            disabledTimeIntervals: [
                [moment().hour(0), moment().hour(9).minutes(0)],
                [moment().hour(18).minutes(0), moment().hour(24)]
            ],
            disabledHours: [0, 1, 2, 3, 4, 5, 6, 7, 8, 18, 19, 20, 21, 22, 23, 24],
            viewDate: moment().add(30, 'minutes'),
            dayViewHeaderFormat: 'MMMM YYYY',
            stepping: 15
        });
    });
});